//@ts-ignore
import React, { ReactNode, useState } from 'react';
import HelpDialog from 'src/components/help-dialog';
import {
  Avatar,
  Box,
  Button,
  Divider,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from 'src/components/mui';
import { TSelectOption, TWhiteLabel } from 'src/components/types';
import { getAsset } from 'src/utils';
import { Icon } from '../icon/Icon';
import { MenuSelect as LanguageSelect } from '../menu-select/MenuSelect';

interface ISettings {
  translation: any;
  whiteLabel?: TWhiteLabel;
  captions: {
    value: boolean;
    onToggle: () => void;
  };
  language?: {
    options: TSelectOption[];
    default: TSelectOption;
    onChange: (lang: TSelectOption) => void;
  };
  termsOfUse: {
    file: string;
    label?: string;
  };
  help: {
    show: boolean;
    label?: string;
  };
  game: {
    label: string;
    user: string;
  };
  components: {
    time: ReactNode;
    points: ReactNode;
    volume: ReactNode;
  };
}

export const Settings = (props: ISettings) => {
  const { translation, whiteLabel, language, components, game, termsOfUse, help, captions } = props;
  const [showHelp, setShowHelp] = useState(false);

  return (
    <>
      <Stack spacing={2}>
        <Typography variant="h5">{game.label}</Typography>
        <Stack direction="row" spacing={4}>
          {game.user && (
            <Stack direction="row" spacing={1} alignItems="center">
              <Icon icon="fa-user" />
              <Typography variant="h6" lineClamp={1}>
                {game.user}
              </Typography>
            </Stack>
          )}
          {components.time}
          {components.points}
        </Stack>

        <Stack spacing={0.5}>
          {components.volume}

          <Stack>
            <FormControlLabel
              control={<Switch checked={captions.value} onChange={captions.onToggle} />}
              label={translation?.subtitles || 'Subtitles'}
            />
          </Stack>
        </Stack>

        {language && language?.options?.length > 0 && (
          <LanguageSelect
            value={language.default}
            placeholder="Language"
            items={language.options}
            onChange={language.onChange}
          />
        )}

        <Box>
          <Divider sx={{ mb: 1 }} />

          <Stack direction="row" spacing={1} justifyContent="space-around" alignItems="center">
            {
              <Button
                onClick={() =>
                  window.open(
                    `${termsOfUse.file || 'https://treedis.com/terms-of-use/'}`,
                    '_blank',
                    'noopener,noreferrer',
                  )
                }
                variant="text"
              >
                {termsOfUse.label || 'Terms of use'}
              </Button>
            }
            {help.show && (
              <Button onClick={() => setShowHelp(true)} variant="text">
                {help.label || 'Help'}
              </Button>
            )}
            <Avatar
              variant="rounded"
              sx={{
                maxWidth: '25%',
                img: { objectFit: 'contain' },
                width: 'auto',
                height: 30,
                cursor: 'pointer',
              }}
              src={whiteLabel?.logo || getAsset('logo-white.svg')}
              onClick={() => window.open(whiteLabel?.website || 'https://treedis.com/', '_blank')}
            />
            <Avatar
              variant="rounded"
              sx={{
                maxWidth: '25%',
                img: { objectFit: 'contain' },
                width: 'auto',
                height: 25,
                cursor: 'pointer',
              }}
              src={getAsset('mp-logo-white.svg')}
              onClick={() => window.open('https://matterport.com/', '_blank')}
            />
          </Stack>
        </Box>
      </Stack>
      {showHelp && (
        <HelpDialog open={showHelp} onClose={() => setShowHelp(false)} translation={translation} />
      )}
    </>
  );
};
